import { CascadiaTheme } from "@certn/cascadia/context/ThemeContext";
import { PropsWithChildren, useState } from "react";
import { I18nProvider } from "react-aria-components";

import { GoogleMapsAPIKeyProvider } from "./GoogleMapsAPIKeyProvider";
import { NavigationProvider } from "./NavigationProvider";
import { ThemeProvider } from "./ThemeProvider";
import { ToastProvider } from "../components/toast/ToastProvider";

interface CascadiaProviderProps extends PropsWithChildren {
  locale: string;
  /** API Key used for address pickers. If not provided, pickers will not work outside of a localhost environment. */
  googleMapsApiKey?: string;
  /** The Cascadia theme to be set. If not provided, a default will be set based on the system theme. */
  theme?: CascadiaTheme;
}

export function CascadiaProvider(props: CascadiaProviderProps) {
  const { theme: initialTheme, locale, children } = props;
  const [theme, setTheme] = useState<CascadiaTheme | undefined>(initialTheme);

  return (
    <I18nProvider locale={locale}>
      <GoogleMapsAPIKeyProvider apiKey={props.googleMapsApiKey}>
        <ThemeProvider theme={theme} setTheme={setTheme}>
          <ToastProvider>
            <NavigationProvider>{children}</NavigationProvider>
          </ToastProvider>
        </ThemeProvider>
      </GoogleMapsAPIKeyProvider>
    </I18nProvider>
  );
}
